import { render, staticRenderFns } from "./TagListingFilters.vue?vue&type=template&id=a482499c"
import script from "./TagListingFilters.vue?vue&type=script&lang=js"
export * from "./TagListingFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports